const isArrayNotEmpty = (value: any) => Array.isArray(value) && value.length > 0;

export default isArrayNotEmpty;



// WEBPACK FOOTER //
// ./src/tools/isarraynotempty.ts